<script lang="ts">
  import type { AcceptedPaymentCardTypes, PaymentCardType } from '$types';

  export let acceptedPaymentCardTypes: AcceptedPaymentCardTypes;
  export let paymentCardTypes: Array<Record<string, PaymentCardType>>;

  function cardEnabled(card: string): boolean {
    if (card === 'dankort' && acceptedPaymentCardTypes?.dankort) {
      return true;
    }
    if (card === 'visa' && (acceptedPaymentCardTypes?.visa_debit || acceptedPaymentCardTypes?.visa_credit)) {
      return true;
    }
    if (card === 'mastercard' && (acceptedPaymentCardTypes?.mastercard_debit || acceptedPaymentCardTypes?.mastercard_credit)) {
      return true;
    }
    return false;
  }
</script>

<!-- Payment Cards Section -->
<div class="cards">
  Optjen med:
  {#each Object.entries(paymentCardTypes[0]) as [cardType, cardData]}
    {#if cardEnabled(cardType)}
      <span class="card">
        <img src={cardData.image_url} alt={cardType} />
      </span>
    {/if}
  {/each}
</div>
